export const projects = [
  {
    key: 1,
    image: "/projectImages/wigle.jpg",
    imageWidth: "380",
    imageHeight: "200",
    title: "Cloth renting app",
    projectLink: "https://github.com/ArchanRD/wigle",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/wigle",
    tags: [
      ["Laravel", "#FFB5343c", "#FF004D"],
      ["PHP", "#7BD3EA59", "#0B60B0"],
      ["Javascript", "#E26EE53c", "#7E30E1"],
      ["Digital Ocean", "#80B3FF3c", "#49108B"],
    ],
  },
  {
    key: 2,
    image: "/projectImages/eccomerce-preview.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Ecommerce & blog",
    projectLink: null,
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/eccommerce",
    tags: [
      ["PHP", "#FFB5343c", "#FF004D"],
      ["Javascript", "#E26EE53c", "#7E30E1"],
    ],
  },
  {
    image: "/projectImages/pokedex.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Pokedex API",
    projectLink: "https://github.com/ArchanRD/pokedex",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/pokedex",
    key: 3,
    tags: [
      ["HTML", "#9ADE7B59", "#508D69"],
      ["CSS", "#FFB5343c", "#FF004D"],
      ["API", "#6C22A63c", "#6962AD"],
    ],
  },
  {
    image: "/projectImages/zomato-preview.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Zomato clone",
    projectLink: "https://github.com/ArchanRD/Zomato-clone",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/zomato",
    key: 4,
    tags: [
      ["HTML", "#9ADE7B59", "#508D69"],
      ["CSS", "#FFB5343c", "#FF004D"],
    ],
  },
  {
    image: "/projectImages/netflix.preview.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Netflix clone",
    projectLink: "https://github.com/ArchanRD/Netflix-clone",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/netflix",
    key: 5,
    tags: [
      ["HTML", "#9ADE7B59", "#508D69"],
      ["CSS", "#FFB5343c", "#FF004D"],
    ],
  },
  {
    image: "/projectImages/quotes-app.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Quotes app",
    projectLink: "https://github.com/ArchanRD/Js-quotes-App-1-",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/quotes",
    key: 6,
    tags: [
      ["HTML", "#9ADE7B59", "#508D69"],
      ["CSS", "#FFB5343c", "#FF004D"],
      ["Javascript", "#6C22A63c", "#6962AD"],
      ["API", "#80B3FF3c", "#49108B"],
    ],
  },
  {
    image: "/projectImages/js-calculator.png",
    imageWidth: "380",
    imageHeight: "200",
    title: "Js Calculator",
    projectLink: "https://github.com/ArchanRD/Javascript-Calculator",
    buttonText: "Github",
    buttonBgColor: "#222831",
    buttonBorderColor: "#FFFFFF",
    buttonLink: "/project/js-calculator",
    key: 7,
    tags: [
      ["Javascript", "#6C22A63c", "#6962AD"],
      ["HTML", "#9ADE7B59", "#508D69"],
      ["CSS", "#FFB5343c", "#FF004D"],
      ["API", "#80B3FF3c", "#49108B"],
    ],
  },
];
